import {orderBy} from "lodash";
let orderByParams = [['sortOrder', 'createdDate'], ['asc', 'desc']];

import {
    bufferCache as cachedClips,
    cachedBuffer as cache,
    makeBufferKey,
    CachedBuffer,
} from '@/services/cached-buffer'

export function openProjectStart(state, projectId) {
    state.clips = []
}

export function openProjectSuccess(state, projectId) {
    state.activeProjectId = projectId
}

export function getVideosSuccess(state, videos) {
    if (videos.length) {
        state.videos.forEach(video => {
            video.createdDate = new Date(video.createdDate).getTime();
        })
        let sortedVideos = orderBy(videos, ...orderByParams);
        state.videos = [...sortedVideos] 

        state.videos.forEach((video, index) => {
            video.sortOrder = index
        })

        // state.videos = state.videos.map(function(video) {
        //     if (video.host === "video" && !video.durationInMilliseconds) {
        //         const buffer = new CachedBuffer({ video });
        //
        //         buffer.player.on("durationchange", function() {
        //             const durationInMilliseconds = buffer.player.duration() * 1000;
        //             video.durationInMilliseconds = durationInMilliseconds;
        //             video.captures.forEach(capture => capture.durationInMilliseconds = durationInMilliseconds)
        //             buffer.removePlayerFromCache();
        //         });
        //     }
        //     return video;
        // });

        state.isLoading = false
    } else {
        state.videos = [];
    }
}

export function setTranscodingJobs(state, transcodingJobs) {
    state.transcodingJobs = [...[], ...transcodingJobs];
    state.hasLoadedTranscodingJobs = true;
}

export function getClipsSuccess(state, clips) {
    state.clips = [...[], ...clips];
    state.isLoading = false;
    
    // state.clips = state.clips.map(function(clip) {
    //     if (clip.video.host === "video" && !clip.video.durationInMilliseconds) {
    //         const buffer = new CachedBuffer(clip);
    //         buffer.player.on("durationchange", function () {
    //             const durationInMilliseconds = buffer.player.duration() * 1000;
    //             clip.video.durationInMilliseconds = durationInMilliseconds;
    //
    //             if (!clip.end_time) {
    //                 clip.end_time = durationInMilliseconds;
    //             }
    //             buffer.removePlayerFromCache();
    //         });
    //     }
    //
    //     return clip;
    // });
    
    clips.filter((clip) => clip.video)
        .filter((clip) => !cachedClips.hasOwnProperty(makeBufferKey(clip)))
        .forEach(clip => cache(clip));
}

export function uploadStart(state, upload) {
    state.uploads.push(upload)
}

export function uploadCancel(state, upload) {
    const index = state.uploads.indexOf(upload)
    state.uploads.splice(index, 1)
}

export function transcodingJobCanceled(state, jobId) {
    const index = state.transcodingJobs.findIndex(job => job.id === jobId);
    state.transcodingJobs.splice(index, 1);
}

export function uploadFinish(state, upload) {
    const index = state.uploads.indexOf(upload)

    if (index !== -1) {
        state.uploads.splice(index, 1)
    } else {
        console.warn(`Upload not found in state.uploads array: ${JSON.stringify(upload)}`)
    }
}

export function jumpToClip(state, clipId) {
    state.playingClipId = clipId
    state.focusedTranscodingClip = null;
}

export function playbackEnded(state) {
    state.playingClipId = null
    state.isPaused = true
}

export function startedEditingClip(state, clip) {
    state.isUnsaved = true;
    state.focusedLegacyVideoId = null
    state.workingClip = { ...clip }
    state.focusedTranscodingClip = null;
    state.isPaused = true


}

export function startedFocusingTranscodingClip(state, clip) {
    state.isUnsaved = true;
    state.focusedLegacyVideoId = null;
    state.workingClip = null;
    state.isPaused = true;
    state.focusedTranscodingClip = {...clip};
}

export function stoppedFocusingTranscodingClip(state) {
    state.isUnsaved = false;
    state.focusedLegacyVideoId = null;
    state.workingClip = null;
    state.isPaused = true;
    state.focusedTranscodingClip = null;
}


export function stoppedEditingClip(state, clip) {
    state.workingClip = null
}

export function openedClipSaveDialog(state) {
    state.isClipSaveDialogOpen = true
}

export function canceledSaveClip(state) {
    state.isClipSaveDialogOpen = false
}

export function saveNewClipStart(state) {
    pushProcessing(state, 'Saving...')
}

export function saveNewClipSuccess(state, clip) {
    state.isClipSaveDialogOpen = false
    state.clips.push(clip)
    popProcessing(state)
}

export function updateClipStart(state, { id, ...fields }) {
    state.isUnsaved = true;
    const clip = state.clips.find(c => c.id == id)

    // Optimistically update
    Object.keys(fields).forEach(fieldName => {
        clip[fieldName] = fields[fieldName]

        if (state.workingClip && state.workingClip.id == id) {
            state.workingClip[fieldName] = clip[fieldName]
        }
    })
}

export function updateClipSuccess(state, { id, ...fields }) {
    //
}

export function deleteClipStart(state, { id }) {
    removeClip(state, id)
}

export function deleteClipSuccess(state, { id }) {
    state.isUnsaved = true;
    removeClip(state, id)
}

function removeClip(state, clipId) {
    state.isUnsaved = true;
    state.clips = state.clips.filter(clip => clip.id != clipId)

    if (state.workingClip && state.workingClip.id == clipId) {
        // Null out the id and treat it as a new clip,
        // since the one it was based on is history.
        state.workingClip.id = null
    }
}

export function reorderClipsStart(state, clips) {
    clips.forEach(({ id, order }) => {
        const clip = state.clips.find(c => c.id == id)
        clip.order = order
    })
}

export function reorderClipsSuccess(state, { id, order }) {
    //
}

function pushProcessing(state, text) {
    state.processingStack.push(text)
}

function popProcessing(state) {
    state.processingStack.pop()
}

export function isSaving(state) {
    if(state.isSaving) {
        state.isSaving = false
    } else {
        state.isSaving = true
    }
}

export function isClipUpdating(state) {
    state.isClipUpdating = !state.isClipUpdating;
}

export function paused(state) {
    state.isPaused = true
}

export function resumed(state) {
    state.isPaused = false
}

export function setPlaybackRate(state, playbackRate) {
    state.playbackRate = playbackRate;
}

export function toggleLibrary(state) {
    if (state.isLibraryExpanded) {
        state.isLibraryExpanded = false
    } else {
        state.isLibraryExpanded = true
    }
}

export function deleteVideosStart(state, videoIds) {
    state.videos = state.videos.filter(video => !videoIds.includes(video.id))
}

export function deleteVideosSuccess(state, videoIds) {
    state.videos = state.videos.filter(video => !videoIds.includes(video.id))
}

export function openedInfoModal(state) {
    state.isInfoModalOpen = true;
}

export function closedInfoModal(state) {
    state.isInfoModalOpen = false;
}

export function getProjectsSuccess(state, projects) {
    state.projects = projects
    state.isLoading = false;
}

export function updateProjects(state) {
    state.isLoading = true;
    pushProcessing(state, 'Saving...')
}

export function updateProjectsSuccess(state, projects) {
    state.isUnsaved = false;
    state.projects = projects;
    state.isLoading = false;
    popProcessing(state)
}

export function openedPublishDialog(state) {
    state.isPublishDialogOpen = true
}

export function canceledPublish(state) {
    state.isPublishDialogOpen = false
}

export function publishStart(state) {
    state.isPublishing = true;
}

export function publishSuccess(state) {
    state.isPublishing = false;
    state.isPublishDialogOpen = false;
    state.publishingErrors = {};
}

export function publishError(state, errors) {
    state.isPublishing = false;
    state.publishingErrors = {...{}, ...errors};
}

export function legacyVideoFocus(state, videoId) {
    state.workingClip = null
    state.focusedLegacyVideoId = videoId
}

export function transcodeRequestStart(state, { videoId }) {
    const video = state.videos.find(video => video.id == videoId)

    video.startedTranscoding = true
}

export function transcodeRequestSuccess(state, { videoId, transcodingJob }) {
    state.transcodingJobs.push(transcodingJob)
}

export function updateIsEditingClipTitleOrDescription(state, status) {
    state.isEditingClipTitleOrDescription = status
}

export function setPanoramaMode(state, mode) {
    state.isPanoramaMode = mode;
}

export function setPanoramicClipData(state, data) {
    state.panoramicClipData = data;
}

export function setPanoramicUploadStatus(state, status) {
    state.isUploadingPanoramicClip = status;
}

export function setIsClipUploadDialogOpen(state, status) {
    state.isClipUploadDialogOpen = status;
}

export function setIsRecording(state, status) {
    state.isRecording = status;
}

export function toggleFailedUpload(state, upload) {
    if (!upload.id) {
        upload.id = Math.random().toString(36).slice(2);
    }

    const index = state.failedUploads.indexOf(upload);

    if (index === -1) {
        state.failedUploads.push(upload);
    } else {
        state.failedUploads.splice(index, 1);
    }
}